export class DialogStateSerializer {
    serializeForStorage(dialogState) {
        return JSON.stringify(dialogState);
    }
    deserializeFromStorage(data) {
        try {
            const dialogState = JSON.parse(data);
            this.assertValid(dialogState);
            return dialogState;
        }
        catch (error) {
            // TODO: inject Sentry to not crash the tests
            // Sentry.logError(error);
            return null;
        }
    }
    // TODO: make it better (e.g. with zod?)
    assertValid(data) {
        if (typeof data !== "object" || data === null) {
            throw new Error("Invalid DialogState");
        }
    }
}
